import { type TaxReturnRequest } from 'app/modules/FormDefinition/models/types';
import { type TaxReturn } from 'app/modules/Reports/TaxReturnList/types';
import { BaseUrlTax } from 'app/modules/taxes/Administration/http';

import httpApiApplication from '../../../../http/httpApiApplication';
import { type TaxReturnForAmendmentDto } from '../../SubmitAmendment/types';
import { type TaxReturnAllowed } from '../models/TaxReturn';

export const baseUrlTaxReturn = '/taxreturns';

export const createTaxReturn = (request: TaxReturnRequest): Promise<any> => {
  return httpApiApplication.post(baseUrlTaxReturn, request);
};

export const CreateAmendTaxReturn = (request: TaxReturnRequest): Promise<any> => {
  return httpApiApplication.post(`${baseUrlTaxReturn}/amend`, request);
};

export const validPeriodicity = (
  year: number,
  periodicityId?: string,
  periodicityItem?: string
): Promise<any> => {
  const queryString = periodicityItem ? `?periodicityItem=${periodicityItem}` : '';
  return httpApiApplication.get(`${BaseUrlTax}/${periodicityId}/${year}${queryString}`);
};

export interface TaxReturnAllowedParams {
  taxId: string;
  taxpayerId: string;
  year: number;
  periodicityTypeId: string;
  periodicityItemId?: string;
}

export const buildTaxReturnAllowedQuery = ({
  taxId,
  taxpayerId,
  year,
  periodicityTypeId,
  periodicityItemId
}: TaxReturnAllowedParams): string => {
  const query = new URLSearchParams();

  query.append('taxId', taxId);
  query.append('taxpayerId', taxpayerId);
  query.append('year', String(year));
  query.append('periodicityTypeId', periodicityTypeId);

  if (periodicityItemId) {
    query.append('periodicityItemId', periodicityItemId);
  }

  return query.toString() ? `?${query.toString()}` : '';
};

export const taxReturnAllowed = (params: TaxReturnAllowedParams): Promise<TaxReturnAllowed> => {
  return httpApiApplication.get(`${baseUrlTaxReturn}/allowed${buildTaxReturnAllowedQuery(params)}`);
};

export const getTaxReturnForAmendment = (
  params: TaxReturnForAmendmentDto
): Promise<TaxReturn> | Promise<any> => {
  return httpApiApplication
    .get(
      `${baseUrlTaxReturn}/gettaxreturnforamendment?taxId=${params.taxId}&taxpayerId=${params.taxpayerId}&year=${params.year}&periodicityType=${params.periodicityType}&periodicityItem=${params.periodicityItem}`
    )
    .then((response) => ({ response }))
    .catch((error) => ({ error }));
};
